
const KEEP_ME_LOGGED_IN_KEY = 'keepMeLoggedIn'

const DEFAULT_KEEP_ME_LOGGED_IN = true

export const setKeepMeLoggedIn = (value: boolean) => {
  localStorage.setItem(KEEP_ME_LOGGED_IN_KEY, value ? 'true' : 'false')
}

export const getKeepMeLoggedIn = (): boolean => {
  const oldValue = localStorage.getItem(KEEP_ME_LOGGED_IN_KEY)
  if (oldValue === null) {
    setKeepMeLoggedIn(DEFAULT_KEEP_ME_LOGGED_IN)
    return DEFAULT_KEEP_ME_LOGGED_IN // default to true
  }
  return localStorage.getItem(KEEP_ME_LOGGED_IN_KEY) === 'true'
}
